import { render, staticRenderFns } from "./SCardInformationComp.vue?vue&type=template&id=5e0fa56e&"
import script from "./SCardInformationComp.vue?vue&type=script&lang=js&"
export * from "./SCardInformationComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports